import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createChangeStatusColorCommand } from '../../../api/commands/factory/createStatusCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeStatusColor extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ChangeStatusColor';

    public constructor(public key: number, public color: string) {
        super(ChangeStatusColor.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeStatusColor): Promise<boolean> => {
    const status = state.subtaskStatuses.find((x) => x.key === action.key);
    return await useSendCommandAsync(action, {
        createCommand: async () => await createChangeStatusColorCommand(state.id, status.key, action.color),
    });
};

const reducer = (state: StorymapState, action: ChangeStatusColor): void => {
    const status = state.subtaskStatuses.find((x) => x.key === action.key);

    status.color = action.color;
};

//@ts-ignore
registerMiddleware(ChangeStatusColor.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeStatusColor.ACTION_TYPE, reducer);
